
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 29 39","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.438 36.055l-13.903-9.57V12.473l13.902-9.57v33.153zM2 26.01h8.534V12.947H2V26.01zM27.902.115a1 1 0 00-1.032.062l-15.648 10.77H1.002a1 1 0 00-1 1V27.01a1 1 0 001 1h10.221l15.649 10.77a1.005 1.005 0 001.032.06 1 1 0 00.535-.884V1a1 1 0 00-.535-.885z","fill-rule":"evenodd","fill":"#FFF"}})])
          )
        }
      }
    